<h2 mat-dialog-title>AGGIUNGI COORDINATE WSZ</h2>
<br>
<mat-dialog-content>
    <mat-form-field>
        <mat-label>Tipologia Coordinate</mat-label>
        <mat-select [(value)]="selectedType">
          <mat-option *ngFor="let dato of dati" [value]="dato.value">{{dato.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
      <br><br>
      <div [ngSwitch]="selectedType">
        <div *ngSwitchCase="'shapeFile'">
          <!-- Sezione ShapeFile -->
          <ng-template matStepLabel>Caricamento ShapeFile</ng-template>
          <div *ngIf="!selectedFile() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
            <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
              <div class="gap-1">
                <div class="text-sm font-semibold uppercase text-700">Carica un file utilizzando l'apposito pulsante</div>
              </div>
              <div
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onFileDrop($event)">
                <span>
                  <app-button *ngIf="!selectedFile()" icon="upload" label="Carica il file" (click)="fileInput.click()" outlined vertical></app-button>
                  <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept="application/zip">
                </span>
                <div *ngIf="dragging" class="drag-overlay"></div>
              </div>
            </div>
          </div>
          <div *ngIf="selectedFile() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
            <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
              <div class="gap-1">
                <div class="text-md font-semibold text-700">{{selectedFile().name}}</div>
                <div class="text-md"><span class="text-700 font-light">Ultima Modifica: </span>{{ selectedFile().lastModified | date:'dd/MM/yyyy' }}</div>
                <div class="text-md"><span class="text-700 font-light">Dimensione: </span>{{ selectedFile().size | appFilesize }}</div>
  
              </div>
              <div >
                <span>
                  <app-button (click)="resetForm()" [disabled]="!canSend()" icon="close" label="Cancella il file" vertical outlined></app-button>
                </span>
              </div>
            </div>
          </div>
        <div class="p-2 flex flex-end w-full" style="justify-content: end;">
          <app-button (click)="onSendClick()" [disabled]="!canSend()"  [fullWidth]="false"  icon="send" label="Mostra Sulla Mappa" raised/>
        </div>
        </div>
        <div *ngSwitchCase="'file-geoJson'">
          <!-- Sezione file GeoJson -->
          <ng-template matStepLabel>Caricamento GeoJson</ng-template>
          <div *ngIf="!selectedFileJson() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
            <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
              <div class="gap-1">
                <div class="text-sm font-semibold uppercase text-700">Carica un file utilizzando l'apposito pulsante</div>
              </div>
              <div
              (dragover)="onDragOverJson($event)"
              (dragleave)="onDragLeaveJson($event)"
              (drop)="onFileDropJson($event)">
                <span>
                  <app-button *ngIf="!selectedFileJson()" icon="upload" label="Carica il file" (click)="fileInput.click()" outlined vertical></app-button>
                  <input hidden (change)="onFileSelectedJson($event)" #fileInput type="file" accept="application/json">
                </span>
                <div *ngIf="dragging" class="drag-overlay"></div>
              </div>
            </div>
          </div>
          <div *ngIf="selectedFileJson() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
            <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
              <div class="gap-1">
                <div class="text-md font-semibold text-700">{{selectedFileJson().name}}</div>
                <div class="text-md"><span class="text-700 font-light">Ultima Modifica: </span>{{ selectedFileJson().lastModified | date:'dd/MM/yyyy' }}</div>
                <div class="text-md"><span class="text-700 font-light">Dimensione: </span>{{ selectedFileJson().size | appFilesize }}</div>
  
              </div>
              <div >
                <span>
                  <app-button (click)="resetForm()" [disabled]="!canSendJson()" icon="close" label="Cancella il file" vertical outlined></app-button>
                </span>
              </div>
            </div>
          </div>
        <div class="p-2 flex flex-end w-full" style="justify-content: end;">
          <app-button (click)="onSendClickGeoJson()" [disabled]="!canSendJson()"  [fullWidth]="false"  icon="send" label="Mostra Sulla Mappa" raised/>
        </div>
        </div>
        <div *ngSwitchCase="'geoJson'">
          <br>
          <!-- Sezione textarea GeoJson -->
          <ng-template matStepLabel>Caricamento GeoJson</ng-template>
          <textarea matInput style="width: 100%;height: 100px;" (input)="checkContent($event)"></textarea>
          <div class="p-2 flex flex-end w-full" style="justify-content: end;">
            <app-button (click)="onSendClickTextArea()" [disabled]="!canSendGeoTextArea()"  [fullWidth]="false"  icon="send" label="Mostra Sulla Mappa" raised/>
          </div>
        </div>
        <div *ngSwitchDefault>
          <!-- Qualcosa da mostrare finché non è selezionato niente -->
        </div>
      </div>
      
</mat-dialog-content>
